import { useMemo } from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import { SelectField } from '../SelectField';
import data3dprint from '../../../../config/data3dprint.json';

interface InfillFieldProps {
  value: number | undefined;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  isActive?: boolean;
  isNext?: boolean;
  disabled?: boolean;
  selectedTechnology: string;
  selectedPrinter: number | undefined;
  selectedMaterial: number | undefined;
  selectedColor: number | undefined;
}

export function InfillField({
  value,
  onChange,
  onFocus,
  onBlur,
  isActive = false,
  isNext = false,
  disabled = false,
  selectedTechnology,
  selectedPrinter,
  selectedMaterial,
  selectedColor
}: InfillFieldProps) {
  const theme = useTheme(state => state.getThemeStyles());

  const options = useMemo(() => {
    const technology = data3dprint.technologies.find(
      tech => tech.name === selectedTechnology
    );
    
    const printer = technology?.printers.find(
      p => p.id === selectedPrinter
    );

    if (!technology || !printer) return [];

    return printer.infill_options.map(infill => ({
      id: infill.id,
      name: `${infill.percentage}%`,
      label: infill.label
    }));
  }, [selectedTechnology, selectedPrinter]);

  const isDisabled = disabled || 
    !selectedTechnology || 
    !selectedPrinter || 
    !selectedMaterial || 
    !selectedColor;

  return (
    <div className={theme.components.input.variants.select.group}>
      <label 
        htmlFor="infill"
        className={`
          ${theme.components.input.variants.select.label.base}
          ${isDisabled ? theme.components.input.variants.select.label.disabled : ''}
        `}
      >
        Preenchimento
      </label>
      <SelectField
        name="infill"
        label="Preenchimento"
        options={options}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        isActive={isActive}
        disabled={isDisabled}
      />
    </div>
  );
} 